export default __webpack_public_path__ + "static/media/Version (1) - Hobbit_01.9fef851c.jpg";